import React from 'react';

import { Row, Col } from 'reactstrap';
import Accordion from '../../../components/Accordion';
import AccordionItem from '../../../components/Accordion/components/AccordionItem';
import BasePlate from '../components/BasePlate';
import SlottedHoles from '../components/SlottedHoles';
import AxisPosition from '../components/AxisPosition';
import BasePlateFactor from '../components/BasePlateFactor';
import StandOffParameters from '../components/StandOffParameters';
import { APP_TEXTS } from '../../../texts/texts';
import { standardList } from '../../../app.values';

const GeneralCalc = (props) => (
  <Row>
    <Col sm="12">
      <Accordion className="application__accordion" appStatus={props.appStatus}>
        <AccordionItem id="base_plate" title={APP_TEXTS.BRACKET_ATTACHMENT_TITLE_BASE_PLATE.Content}>
          <BasePlate/>
        </AccordionItem>
        <AccordionItem id="slotted_holes" title={APP_TEXTS.SLOTTED_HOLES_TITLE.Content}>
          <SlottedHoles/>
        </AccordionItem>
        <AccordionItem id="axis_position" title={APP_TEXTS.BRACKET_ATTACHMENT_TITLE_AXIS_POSITION.Content}>
          <AxisPosition/>
        </AccordionItem>
        <AccordionItem id="base_plate_factor" title={APP_TEXTS.BRACKET_ATTACHMENT_TITLE_BASE_PLATE_FACTOR.Content}>
          <BasePlateFactor/>
        </AccordionItem>
        {Number(props.designStandard) !== standardList['Masonry'] && (
          <AccordionItem id="stand-off-parameters" title={APP_TEXTS.STAND_OFF_PARAMETERS_TITLE.Content}>
            <StandOffParameters/>
          </AccordionItem>
        )}
      </Accordion>
    </Col>
  </Row>
);

export default GeneralCalc;



// WEBPACK FOOTER //
// ./src/views/Dimension/GeneralCalc/GeneralCalc.js